export enum PhotoRoute {
  Photo = 'photo',
}
